import React, { useRef, useState, useEffect } from "react";
import { Col, Row, Modal, Form, Input, Select, Button, Space, Tooltip, Steps, Card } from "antd";
import { DeleteFilled, PlusOutlined, SaveFilled, LeftOutlined, RightOutlined } from "@ant-design/icons";
import chainIcon from "../../../Navbar/assets/chain.png";

const { Option } = Select;

const DependencyModal = ({
  isVisible,
  onClose,
  onSave,
  form,
  selectedDependency,
  dependencyTypes,
  assets,
  attributes,
  inputRef,
  api
}) => {
  const addRef = useRef(null);
  const [currentStep, setCurrentStep] = useState(0);
  const [usedAttributes, setUsedAttributes] = useState(new Set());

  // Función para actualizar usedAttributes
  const updateUsedAttributes = () => {
    const currentFields = form.getFieldValue("atributes") || [];
    const currentlyUsed = new Set();
    
    currentFields.forEach((field) => {
      if (field?.atribute) {
        const attributeId = typeof field.atribute === 'object' ? field.atribute.id : field.atribute;
        currentlyUsed.add(attributeId);
      }
    });
    
    setUsedAttributes(currentlyUsed);
  };

  const next = async () => {
    try {
      const fieldsToValidate = currentStep === 0 
        ? ['name', 'description', 'asset', 'area_name', 'type']
        : [];
      
      if (fieldsToValidate.length > 0) {
        await form.validateFields(fieldsToValidate);
      }
      setCurrentStep((prev) => prev + 1);
    } catch (error) {
      console.log('Validación fallida:', error);
    }
  };

  const prev = () => setCurrentStep((prev) => prev - 1);

  useEffect(() => {
    if (isVisible) {
      setCurrentStep(0);
      setTimeout(() => {
        updateUsedAttributes();
      }, 200);
    }
  }, [isVisible]);

  useEffect(() => {
    if (currentStep === 1) {
      updateUsedAttributes();
    }
  }, [currentStep]);

  const handleModalClose = () => {
    setCurrentStep(0);
    setUsedAttributes(new Set());
    onClose();
  };

  const handleFormSubmit = async () => {
    try {
      const values = await form.validateFields();
      
      if (!Array.isArray(values.atributes) || values.atributes.length === 0 || 
          !values.atributes[0]?.atribute || !values.atributes[0]?.value) {
        console.error("Debes agregar al menos un atributo completo antes de guardar.");
        return;
      }
      
      onSave(values);
    } catch (error) {
      console.log('Error en validación:', error);
    }
  };

  // Función para obtener el ID del atributo actual de un campo
  const getCurrentAttributeId = (fieldName) => {
    const currentValue = form.getFieldValue(["atributes", fieldName, "atribute"]);
    if (!currentValue) return null;
    
    return typeof currentValue === 'object' ? currentValue.id : currentValue;
  };

  const isAddButtonDisabled = () => {
    const currentFields = form.getFieldValue("atributes") || [];
    return currentFields.length >= attributes.length;
  };

  const steps = [
    {
      title: "Información General",
      content: (
        <>
          <Form.Item
            name="name"
            label="Nombre"
            rules={[{ required: true, message: "Nombre requerido" }]}
            preserve
          >
            <Input.TextArea
              ref={inputRef}
              maxLength={50}
              showCount
              style={{ resize: "none", width: "100%" }}
            />
          </Form.Item>

          <Form.Item
            name="description"
            label="Descripción"
            rules={[{ required: true, message: "Descripción requerida" }]}
            preserve
          >
            <Input.TextArea
              maxLength={300}
              showCount
              style={{ resize: "none", width: "100%", height: "120px" }}
            />
          </Form.Item>

          <Form.Item
            name="asset"
            label="Activo Asociado"
            rules={[{ required: true, message: "Selecciona un activo" }]}
            preserve
          >
            <Select
              allowClear
              placeholder="Seleccione un Activo"
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              onChange={(value) => {
                const selectedAsset = assets.find((asset) => asset.code === value);
                if (selectedAsset?.area) {
                  form.setFieldsValue({ area_name: selectedAsset.area.name });
                } else {
                  form.setFieldsValue({ area_name: undefined });
                }
              }}
            >
              {assets.map((asset) => (
                <Option key={asset.code} value={asset.code}>
                  {asset.name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Row gutter={[8, 0]}>
            <Col span={12}>
              <Form.Item
                name="area_name"
                label="Responsable"
                rules={[{ required: true, message: "Responsable requerido" }]}
                preserve
              >
                <Input disabled placeholder="Área responsable" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name="type"
                label="Tipo de Dependencia"
                rules={[{ required: true, message: "Selecciona un tipo de dependencia" }]}
                preserve
              >
                <Select
                  placeholder="Seleccione un Tipo"
                  showSearch
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {dependencyTypes.map((type) => (
                    <Option key={type.id} value={type.id}>
                      {type.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </>
      ),
    },
    /* {
      title: "Atributos",
      content: (
        <Form.Item
          label={
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span>Atributos</span>
              <Tooltip title="Agregar Atributo">
                <Button
                  size="small"
                  type="text"
                  className="add-type-button"
                  icon={<PlusOutlined />}
                  onClick={() => addRef.current?.()}
                  style={{ marginLeft: "8px" }}
                />
              </Tooltip>
            </div>
          }
        >
          <Form.List name="atributes" preserve>
            {(fields, { add, remove }) => {
              const handleAdd = () => {
                const currentFields = form.getFieldValue("atributes") || [];
                
                if (currentFields.length > 0) {
                  const lastField = currentFields[currentFields.length - 1];
                  if (!lastField?.atribute || !lastField?.value) {
                    api.error({
                      message: "Atributo incompleto",
                      description: "Completa el atributo anterior antes de agregar uno nuevo.",
                      placement: "topRight",
                      key: 'atributes'
                    });
                    return;
                  }
                }
                
                const totalCurrentFields = currentFields.length;
                
                if (totalCurrentFields < attributes.length) {
                  add();
                  setTimeout(updateUsedAttributes, 100);
                }
              };

              addRef.current = handleAdd;

              const handleRemove = (name) => {
                remove(name);
                setTimeout(updateUsedAttributes, 100);
              };

              const handleAttributeChange = () => {
                setTimeout(updateUsedAttributes, 100);
              };

              return (
                <div className="attributes-container">
                  {fields.map(({ key, name, ...restField }) => {
                    const currentAttributeId = getCurrentAttributeId(name);
                    
                    return (
                      <Row gutter={[8, 0]} key={key} style={{ marginBottom: 8 }}>
                        <Col span={11}>
                          <Form.Item
                            {...restField}
                            name={[name, "atribute"]}
                            rules={[{ required: true, message: "Selecciona un atributo" }]}
                            preserve
                            style={{ marginBottom: 0 }}
                          >
                            <Select
                              placeholder="Seleccione un Atributo"
                              showSearch
                              filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                              }
                              onChange={handleAttributeChange}
                            >
                              {attributes.map((attr) => {
                                const isUsed = usedAttributes.has(attr.id);
                                const isCurrent = currentAttributeId === attr.id;
                                const isDisabled = isUsed && !isCurrent;
                                
                                return (
                                  <Option
                                    key={attr.id}
                                    value={attr.id}
                                    disabled={isDisabled}
                                  >
                                    {attr.key}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col span={11}>
                          <Form.Item
                            {...restField}
                            name={[name, "value"]}
                            rules={[{ required: true, message: "Ingresa el valor" }]}
                            preserve
                            style={{ marginBottom: 0 }}
                          >
                            <Input
                              maxLength={50}
                              showCount
                              placeholder="Valor"
                              style={{ width: "100%" }}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={2}>
                          <Button
                            className="delete-button"
                            icon={<DeleteFilled />}
                            onClick={() => handleRemove(name)}
                            disabled={fields.length === 1} 
                            style={{ 
                              width: "100%", 
                              height: "32px",
                              opacity: fields.length === 1 ? 0.5 : 1,
                              cursor: fields.length === 1 ? 'not-allowed' : 'pointer'  
                            }}
                          />
                        </Col>
                      </Row>
                    );
                  })}
                </div>
              );
            }}
          </Form.List>
        </Form.Item>
      ),
    }, */
    {
      title: "Atributos",
      content: (
        <Form.Item
          label={
            <div style={{ 
              display: "flex", 
              alignItems: "center", 
              gap: "8px" 
            }}>
              <span>Atributos</span>
              <Tooltip title={isAddButtonDisabled() ? "Todos los atributos ya están asignados" : "Agregar Atributo"}>
                <Button 
                  size="small" 
                  type="text" 
                  className={isAddButtonDisabled() ? "add-type-button-disabled" : "add-type-button"}
                  icon={<PlusOutlined />} 
                  onClick={() => addRef.current?.()} 
                  disabled={isAddButtonDisabled()}
                  style={{ 
                    opacity: isAddButtonDisabled() ? 0.5 : 1,
                    cursor: isAddButtonDisabled() ? 'not-allowed' : 'pointer'
                  }} 
                />
              </Tooltip>
            </div>
          }
        >
          <Form.List name="atributes" preserve>
            {(fields, { add, remove }) => {
              const handleAdd = () => {
                const currentFields = form.getFieldValue("atributes") || [];
                
                if (currentFields.length > 0) {
                  const lastField = currentFields[currentFields.length - 1];
                  if (!lastField?.atribute || !lastField?.value) {
                    api.error({
                      message: "Atributo incompleto",
                      description: "Completa el atributo anterior antes de agregar uno nuevo.",
                      placement: "topRight",
                      key: 'atributes'
                    });
                    return;
                  }
                }
                
                const totalCurrentFields = currentFields.length;
                
                if (totalCurrentFields < attributes.length) {
                  add();
                  setTimeout(updateUsedAttributes, 100);
                }
              };

              addRef.current = handleAdd;

              const handleRemove = (name) => {
                remove(name);
                setTimeout(updateUsedAttributes, 100);
              };

              const handleAttributeChange = () => {
                setTimeout(updateUsedAttributes, 100);
              };

              return (
                <div className="attributes-container">
                  {fields.map(({ key, name, ...restField }) => {
                    const currentAttributeId = getCurrentAttributeId(name);
                    
                    return (
                      <Row gutter={[8, 0]} key={key} style={{ marginBottom: 8 }}>
                        <Col span={11}>
                          <Form.Item
                            {...restField}
                            name={[name, "atribute"]}
                            rules={[{ required: true, message: "Selecciona un atributo" }]}
                            preserve
                            style={{ marginBottom: 0 }}
                          >
                            <Select
                              placeholder="Seleccione un Atributo"
                              showSearch
                              filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                              }
                              onChange={handleAttributeChange}
                            >
                              {attributes.map((attr) => {
                                const isUsed = usedAttributes.has(attr.id);
                                const isCurrent = currentAttributeId === attr.id;
                                const isDisabled = isUsed && !isCurrent;
                                
                                return (
                                  <Option
                                    key={attr.id}
                                    value={attr.id}
                                    disabled={isDisabled}
                                  >
                                    {attr.key}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col span={11}>
                          <Form.Item
                            {...restField}
                            name={[name, "value"]}
                            rules={[{ required: true, message: "Ingresa el valor" }]}
                            preserve
                            style={{ marginBottom: 0 }}
                          >
                            <Input
                              maxLength={50}
                              showCount
                              placeholder="Valor"
                              style={{ width: "100%" }}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={2}>
                          <Button
                            className="delete-button"
                            icon={<DeleteFilled />}
                            onClick={() => handleRemove(name)}
                            disabled={fields.length === 1} 
                            style={{ 
                              width: "100%", 
                              height: "32px",
                              opacity: fields.length === 1 ? 0.5 : 1,
                              cursor: fields.length === 1 ? 'not-allowed' : 'pointer'  
                            }}
                          />
                        </Col>
                      </Row>
                    );
                  })}
                </div>
              );
            }}
          </Form.List>
        </Form.Item>
      ),
    },
  ];

  return (
    <Modal
      className="dependency-modal"
      title={
        <span>
          <img
            src={chainIcon}
            alt="Dependencias"
            style={{ marginRight: 8, width: 18, height: 18 }}
          />
          {selectedDependency ? "Editar Dependencia" : "Agregar Dependencia"}
        </span>
      }
      open={isVisible}
      onCancel={handleModalClose}
      footer={null}
      centered
      destroyOnClose={false}
      style={{ 
        maxWidth: '90vw',
        left: 0,
        right: 0,
        marginLeft: 'auto',
        marginRight: 'auto'
      }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{ atributes: [{}] }}
      >
        <Steps
          current={currentStep}
          items={steps.map((step) => ({ title: step.title }))}
          style={{ marginBottom: 30 }}
        />

        <Card style={{ borderRadius: 12, marginBottom: 20, minHeight: 400 }}>
          <div style={{ display: currentStep === 0 ? 'block' : 'none' }}>
            {steps[0].content}
          </div>
          <div style={{ display: currentStep === 1 ? 'block' : 'none' }}>
            {steps[1].content}
          </div>
        </Card>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {currentStep > 0 ? (
            <Button 
              type="button"
              className="cancel-button" 
              onClick={prev} 
              icon={<LeftOutlined />}
            >
              Anterior
            </Button>
          ) : (
            <Button 
              type="button"
              className="cancel-button" 
              onClick={handleModalClose}
            >
              Cancelar
            </Button>
          )}

          {currentStep < steps.length - 1 ? (
            <Button 
              type="button"
              className="save-type-button" 
              onClick={next} 
              icon={<RightOutlined />}
            >
              Siguiente
            </Button>
          ) : (
            <Button
              type="primary"
              onClick={handleFormSubmit}
              icon={<SaveFilled />}
              className="save-type-button"
            >
              Guardar
            </Button>
          )}
        </div>
      </Form>
    </Modal>
  );
};

export default DependencyModal;